module.exports = __webpack_public_path__ + "static/img/person.2f5c70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person.png
// module id = Xi0g
// module chunks = 61